import "core-js/modules/es.array.push.js";
export default {
  name: "LCAside",
  data() {
    return {
      isCollapse: false,
      authorityId: '',
      authList: [],
      timeT: ''
    };
  },
  created() {
    this.getList();
    // this.load()
  },

  methods: {
    getList() {
      this.authList = [];
      let user = sessionStorage.getItem('authorityId'); //1,2,3
      console.log(user);
      console.log(typeof user);
      // 防止未登录时 user 为 null 导致崩溃
      if (!user || user === 'null' || user === 'undefined') {
        this.authList = [];
        return;
      }
      if (user.length > 1) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.authList = user.split(",");
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        //   this.authList = Object.values(this.authList)
        console.log(user.split(","));
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        console.log(typeof this.list);
        console.log(typeof Object.values(this.authList));
        console.log(typeof user.split(","));
        console.log(this.authList);

        // for (( value,index) in this.authList) {
        //   console.log(this.authList)
        // }

        console.log(this.authList[0]);
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      } else if (user.length === 1) {
        this.authList = user;
        console.log(user.authorityId);
      }
      // return this.$store.getters.getCurrentPathName;
    },

    load() {
      console.log("-----1111");
      this.timeT = setTimeout(() => {
        this.authorityId = sessionStorage.getItem('authorityId');
        console.log(this.authorityId + "-----aside---authorityId");
        // Object.keys(this.user).forEach((key,index) => {
        //     console.log( key,index, this.user[key])
        // })
        // if(this.user!=null){
        //     console.log(this.user.authorityId);
        // if(this.user.authorityId.length>1){
        //     this.authList = this.user.authorityId.split(",");
        // }else this.authList.push(this.user.authorityId);
        // }
      }, 1000);
      // clearTimeout(this.timeT);
    },

    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
    toDevice() {
      if (this.authList.indexOf('14') !== -1) {
        this.$router.push({
          path: 'Device'
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toDeviceStatus() {
      this.$router.push({
        path: 'DeviceStatus'
      });
    },
    toTemplate() {
      if (this.authList.indexOf('15') !== -1) {
        this.$router.push({
          path: 'Template',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toDetec() {
      if (this.authList.indexOf('4') !== -1) {
        localStorage.setItem("currentPathName", "检测报告初检");
        this.$router.push({
          path: 'startDetect',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toWeave() {
      if (this.authList.indexOf('5') !== -1) {
        localStorage.setItem("currentPathName", "检测报告编制");
        this.$router.push({
          path: 'record',
          query: {
            RecordFlag: 0
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toAudit() {
      if (this.authList.indexOf('6') !== -1) {
        localStorage.setItem("currentPathName", "检测报告审核");
        this.$router.push({
          path: 'record',
          query: {
            RecordFlag: 5
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toApprove() {
      if (this.authList.indexOf('7') !== -1) {
        localStorage.setItem("currentPathName", "检测报告批准");
        this.$router.push({
          path: 'record',
          query: {
            RecordFlag: 2
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toQuery() {
      if (this.authList.indexOf('8') !== -1) {
        localStorage.setItem("currentPathName", "检测报告查询");
        this.$router.push({
          path: 'record',
          query: {
            RecordFlag: 3
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toUpload() {
      if (this.authList.indexOf('9') !== -1) {
        localStorage.setItem("currentPathName", "检测报告上传");
        this.$router.push({
          path: 'record',
          query: {
            RecordFlag: 4
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toRole() {
      if (this.authList.indexOf('11') !== -1) {
        this.$router.push({
          path: 'Role',
          query: {}
        });
        // if (this.authList.toString().split(",").findIndex(item => item === '15')) {
        //   console.log(this.authList.toString().split(","))
        //   console.log(this.authList.indexOf('12'))
        //   console.log(typeof this.authList.toString().split(","))
        //     console.log("真")
        //   } else {
        //     console.log("假")
        //   }
      } else {
        console.log(this.authList.findIndex(item => item === 11));
        console.log(this.authList.toString());
        // if (this.authList.findIndex(item => item === 11)) {
        //   console.log("真")
        // } else {
        //   console.log("假")
        // }
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toUser() {
      if (this.authList.indexOf('12') !== -1) {
        this.$router.push({
          path: 'UserList',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toArea() {
      if (this.authList.indexOf('13') !== -1) {
        this.$router.push({
          path: 'AreaSetIndex',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toTool() {
      if (this.authList.indexOf('19') !== -1) {
        this.$router.push({
          path: 'Tool',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toCap() {
      if (this.authList.indexOf('21') !== -1) {
        this.$router.push({
          path: 'Cap',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toOrder(show) {
      console.log(this.authList);
      // for (let i = 0; i < this.authList.length; i++) {
      //   console.log(this.authList[i])
      localStorage.setItem("currentPathName", "任务创建");
      if (this.authList.indexOf('1') !== -1) {
        this.$router.push({
          path: 'Order',
          query: {
            show: show
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
      // }
    },

    toOrder2(show) {
      localStorage.setItem("currentPathName", "任务分配");
      if (this.authList.indexOf('2') !== -1) {
        this.$router.push({
          path: 'Order',
          query: {
            show: show
          }
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toOrderGet() {
      if (this.authList.indexOf('3') !== -1) {
        this.$router.push({
          path: 'OrderGet',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toSeal() {
      if (this.authList.indexOf('16') !== -1) {
        this.$router.push({
          path: 'Seal',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toState() {
      if (this.authList.indexOf('18') !== -1) {
        this.$router.push({
          path: 'State',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toPay() {
      if (this.authList.indexOf('22') !== -1) {
        this.$router.push({
          path: 'pay',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toOrderinfo() {
      if (this.authList.indexOf('23') !== -1) {
        this.$router.push({
          path: 'orderinfo',
          query: {}
        });
      } else {
        this.$router.push({
          path: 'home',
          query: {}
        });
        this.$message({
          message: '无权限！',
          type: 'error'
        });
      }
    },
    toData() {
      this.$router.push({
        path: 'dataShow',
        query: {}
      });
    }
  }

  // beforeDestroy() {
  //     clearTimeout(this.timeT);
  // },
};